import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { CATEGORIES, ACTIVE_CATEGORIES } from '../../lib/categories';
import { listProgressionEntries } from '../../lib/last-played';
import { MAX_LEVEL } from '../../lib/game-progression';
import { SectionMarker } from '../../components/SectionMarker';
import { DomainCard } from '../../components/DomainCard';
import { FooterState } from '../../components/FooterState';
export function LibraryIndex() {
    const { t } = useTranslation(['library', 'common']);
    const rows = useMemo(() => {
        const entries = listProgressionEntries();
        const byGame = new Map(entries.map((e) => [e.slug, e]));
        return CATEGORIES.map((cat) => {
            if (cat.gameSlugs.length === 0) {
                return {
                    cat,
                    avgLevel: 1,
                    pctProgress: 0,
                    gameCount: 0,
                };
            }
            const levels = cat.gameSlugs.map((g) => byGame.get(g)?.bestLevel ?? 1);
            const avg = levels.reduce((a, b) => a + b, 0) / levels.length;
            const pct = Math.min(100, Math.max(0, ((avg - 1) / (MAX_LEVEL - 1)) * 100));
            return {
                cat,
                avgLevel: Math.round(avg),
                pctProgress: pct,
                gameCount: cat.gameSlugs.length,
            };
        });
    }, []);
    const totalGames = rows.reduce((a, r) => a + r.gameCount, 0);
    const activeCount = ACTIVE_CATEGORIES.length;
    const pendingCount = CATEGORIES.length - activeCount;
    return (_jsxs("section", { className: "flex flex-1 flex-col gap-7 pt-2 pb-4", children: [_jsxs("header", { className: "flex flex-col gap-3", children: [_jsx(SectionMarker, { num: "01", label: t('library:eyebrow') }), _jsx("h1", { className: "font-display text-[32px] font-medium leading-[1.05] tracking-cy-display text-cyan-text", children: t('library:title', { categories: CATEGORIES.length }) }), _jsx("p", { className: "text-[13px] font-light text-cyan-text-secondary", children: t('library:subtitle', { games: totalGames }) })] }), _jsx("ul", { className: "grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3 md:gap-4 lg:gap-6 items-start", children: rows.map((row, idx) => (_jsx(DomainCard, { cat: row.cat, index: idx, avgLevel: row.avgLevel, pctProgress: row.pctProgress, gameCount: row.gameCount }, row.cat.slug))) }), _jsx("div", { className: "mt-auto pt-4", children: _jsx(FooterState, { state: t('library:footer_state_m3', {
                        total: CATEGORIES.length,
                        active: activeCount,
                        pending: pendingCount,
                    }), coord: t('library:footer_coord') }) })] }));
}
//# sourceMappingURL=index.js.map